var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', {
    staticClass: "mb-15"
  }, [_vm._v("\n    Compétences personnelles\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-5"
  }, [_vm._l(_vm.criterions, function (compPerso, iPerso) {
    return _c('div', {
      key: iPerso,
      staticClass: "flex flex-col space-y-2.5"
    }, [iPerso > 0 || _vm.criterions.length > 1 ? _c('div', {
      staticClass: "mr-2 pt-4"
    }, [_c('delete-button', {
      attrs: {
        "libelle": "Supprimer la compétence"
      },
      on: {
        "del": function ($event) {
          return _vm.deleteCompetence(iPerso);
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "grid grid-cols-4 gap-4",
      attrs: {
        "id": "competencesPersoForm"
      }
    }, [_c('div', {
      staticClass: "col-span-full md:col-span-2 lg:col-span-1"
    }, [_c('input-select', {
      attrs: {
        "name": 'categoriesPerso' + iPerso,
        "libelle": "Catégorie et référentiel",
        "datas": _vm.referentiel,
        "value-is-object": true,
        "value": compPerso.values.categories
      },
      on: {
        "input": function (newValue) {
          if (!_vm.freezeDatas) _vm.getDatas('domaines', iPerso, newValue);
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-full md:col-span-2 lg:col-span-1"
    }, [_c('input-select', {
      attrs: {
        "name": 'domainesPerso' + iPerso,
        "libelle": "Domaine",
        "datas": _vm.criterions[iPerso].datas.domaines,
        "value": compPerso.values.domaines,
        "value-is-object": true
      },
      on: {
        "input": function (newValue) {
          if (!_vm.freezeDatas) _vm.getDatas('competences', iPerso, newValue);
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-full md:col-span-2 lg:col-span-1"
    }, [_c('input-select', {
      attrs: {
        "name": 'competencesPerso' + iPerso,
        "libelle": "Compétences",
        "datas": _vm.criterions[iPerso].datas.competences,
        "value": compPerso.values.competences,
        "value-is-object": true
      },
      on: {
        "input": function (newValue) {
          if (!_vm.freezeDatas) _vm.getDatas('niveaux', iPerso, newValue);
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-full md:col-span-2 lg:col-span-1"
    }, [_c('input-select', {
      attrs: {
        "name": 'niveauxPerso' + iPerso,
        "libelle": "Niveau (minimum)",
        "datas": _vm.criterions[iPerso].datas.niveaux,
        "value": compPerso.values.niveaux,
        "value-is-object": true
      },
      on: {
        "input": function (newValue) {
          if (!_vm.freezeDatas) _vm.setSearching('niveaux', iPerso, newValue);
        }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "flex flex-wrap space-y-2.5 items-baseline",
      attrs: {
        "id": "tagsCompPerso"
      }
    }, [Object.values(compPerso.values.categories).length > 0 ? _c('tag', {
      staticClass: "mr-2.5",
      attrs: {
        "libelle": compPerso.values.categories.value,
        "theme-color": "indigo",
        "is-closeable": true,
        "text-size": "text-sm",
        "text-font": "font-light"
      },
      on: {
        "close": function ($event) {
          return _vm.setSearching('categories', iPerso, {});
        }
      }
    }) : _vm._e(), _vm._v(" "), Object.values(compPerso.values.domaines).length > 0 ? _c('tag', {
      staticClass: "mr-2.5",
      attrs: {
        "libelle": compPerso.values.domaines.value,
        "theme-color": "pink",
        "is-closeable": true,
        "text-size": "text-sm",
        "text-font": "font-light"
      },
      on: {
        "close": function ($event) {
          return _vm.setSearching('domaines', iPerso, {});
        }
      }
    }) : _vm._e(), _vm._v(" "), Object.values(compPerso.values.competences).length > 0 ? _c('tag', {
      staticClass: "mr-2.5",
      attrs: {
        "libelle": compPerso.values.competences.value,
        "theme-color": "teal",
        "is-closeable": true,
        "text-size": "text-sm",
        "text-font": "font-light"
      },
      on: {
        "close": function ($event) {
          return _vm.setSearching('competences', iPerso, {});
        }
      }
    }) : _vm._e(), _vm._v(" "), Object.values(compPerso.values.niveaux).length > 0 ? _c('tag', {
      staticClass: "mr-2.5",
      attrs: {
        "libelle": compPerso.values.niveaux.value,
        "theme-color": "orange",
        "is-closeable": true,
        "text-size": "text-sm",
        "text-font": "font-light"
      },
      on: {
        "close": function ($event) {
          return _vm.setSearching('niveaux', iPerso, {});
        }
      }
    }) : _vm._e()], 1)]);
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "addCompPersoButton"
    }
  }, [_c('add-button', {
    staticClass: "hidden sm:flex",
    attrs: {
      "libelle": "Ajouter une compétence personnelle"
    },
    on: {
      "add": _vm.addCompetence
    }
  }), _vm._v(" "), _c('add-button', {
    staticClass: "sm:hidden",
    attrs: {
      "libelle": ""
    },
    on: {
      "add": _vm.addCompetence
    }
  })], 1)], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }